import renderPage, { renderInContainer } from "../../utils/renderPage";
import applyStyles from "../../utils/applyStyles";

export function renderLoaded(anchor, data, isPlaceholder = false) {
    applyStyles(data.css);
    if (isPlaceholder) {
        return renderInContainer(anchor, data.posts_html);
    } else {
        return renderPage(anchor, data.posts_html);
    }
}

export function calculateLoadingHeight(containerElement) {
    let height = window.innerHeight;
    const postsHolder = containerElement.querySelector(".posts-custom");
    if (postsHolder) {
        height = postsHolder.offsetHeight;
    } else {
        const articles = containerElement.querySelectorAll("article");
        if (articles.length) {
            const lastArticle = articles[articles.length - 1];
            height = Math.min(height * 6, Math.max(lastArticle.offsetHeight * 6, height));
        }
    }
    return height;
}

function doesHaveMore(node) {
    return node.dataset.hasMore && node.dataset.hasMore !== "false";
}

export function hasMoreContent(node) {
    const hasMoreAttrNodes = Array.from(node.querySelectorAll("[data-has-more]")).filter(
        doesHaveMore
    );
    if (doesHaveMore(node)) {
        hasMoreAttrNodes.push(node);
    }

    if (hasMoreAttrNodes.length) {
        return true;
    } else {
        return false;
    }
}
